import 'pixi.js';
import 'pixi-spine';
import 'pixi-extra-filters';
import 'pixi-particles';
import 'pixi-text-input';

import jquery from 'jquery';

import * as THREE from 'three';

import '../libs/BufferGeometryUtils';
import '../libs/MapControls.js';

import '../libs/tweenmax.min';
import '../libs/p3.min';

import './utils';

import Main from './Main';

global.$ = jquery;
global.THREE = THREE;

console.log(location.href, new Date());	// When QA send me error reports, its useful to know what link they're coming from and when they tested

//window.start = () => {
	const main = new Main();
	main.init();
//};
